export default __webpack_public_path__ + "static/masthead_bg_desktop-c4ecf0f0f9efa62c9e91717febf2e385.png";